var map = {
	"./common.png": "c7c0",
	"./epic.png": "05ef",
	"./legendary.png": "caf3",
	"./prototype.png": "cbf8",
	"./superior.png": "8fde",
	"./uncommon.png": "d791"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "693e";